// @ts-nocheck
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://auth.cern.ch/auth',
  realm: 'cern',
  clientId: window.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export const keycloakConfig = {
  keycloak,
  initOptions: {
    onLoad: 'login-required',
  },
  loginOptions: {
    checkLoginIframe: false,
    scope: 'openid',
  },
};

export default keycloak;
